import R from 'ramda';

export const getHashTagsFromString = R.compose(
  R.map(str => str.toLowerCase()),
  R.uniq,
  R.match(/#\w+/g)
);

export const parseMessage = (str) => {
  const splitted = R.call(R.compose(
    R.filter(R.prop('value')),
    R.flatten,
    R.addIndex(R.map)((subStr, i) => {
      if (i) {
        const addedBackHash = `#${subStr}`;
        const tag = R.match(/#\w+/g)(addedBackHash)[0];
        return [{
          value: tag,
          type: 'hashtag',
        }, {
          value: addedBackHash.replace(tag, ''),
          type: 'string',
        }];
      }
      return {
        value: subStr,
        type: 'string',
      };
    }),
    R.split('#')
  ), str);
  return splitted;
};



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/helperFuncs.js